module.exports = __webpack_public_path__ + "img/values.0f1ba663.jpg";